import { Chip, Box } from "@mui/material";
import RemoveButton from "./RemoveButton";

const styles = {
  maxWidth: "100%",
  height: "auto",
  "& .MuiChip-label": {
    whiteSpace: "normal",
    overflowWrap: "break-word",
    textAlign: "left",
    display: "block",
    lineHeight: 1.2,
    paddingY: "6px",
  },
};

const NomenclatureOrderItem = ({ item, onRemove, showRemoveButton, chipSx }) => (
  <Box>
    <Chip
      label={item.name}
      size="medium"
      color="primary"
      onDelete={showRemoveButton ? onRemove : undefined}
      deleteIcon={
        showRemoveButton ? (
          <RemoveButton tooltip="Remover Práctica" color="#fff" />
        ) : undefined
      }
      sx={{ ...styles, ...chipSx }}
    />
  </Box>
);

export default NomenclatureOrderItem;
